import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2937471d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header w-100 pt-10\" data-v-2937471d><div class=\"row w-100\" data-v-2937471d><div class=\"col-12 col-lg-6 col-md-6 col-sm-12\" data-v-2937471d><div class=\"card-title m-0\" data-v-2937471d><h3 class=\"fw-bolder m-0\" data-v-2937471d>Subscription</h3></div></div></div></div>", 1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Add Business Details ")
const _hoisted_4 = { class: "w-100 card-body d-flex flex-row p-0 gap-5" }
const _hoisted_5 = { class: "w-50 px-10 pt-10" }
const _hoisted_6 = { class: "w-50 px-10 pt-10" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end pb-10 px-10 gap-5" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "btn btn-link disabled" }, "Change"),
  /*#__PURE__*/_createElementVNode("a", { class: "btn btn-danger disabled" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, "Cancel Subscription"),
    /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
      /*#__PURE__*/_createTextVNode("Please wait... "),
      /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
    ])
  ])
], -1))
const _hoisted_8 = {
  key: 0,
  class: "card-body d-flex flex-column px-0 pt-0"
}
const _hoisted_9 = { class: "d-flex flex-row gap-3 px-10 pt-10" }
const _hoisted_10 = { class: "w-50 d-flex flex-column" }
const _hoisted_11 = { class: "d-flex flex-row mb-7" }
const _hoisted_12 = {
  key: 0,
  class: "fw-bolder m-0"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bi bi-clock-fill" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bi bi-clock-fill" }, null, -1))
const _hoisted_15 = { class: "d-flex flex-row mb-7" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "w-25 fw-bold text-muted" }, "Current Period ", -1))
const _hoisted_17 = { class: "w-75 fw-bold fs-6" }
const _hoisted_18 = { class: "d-flex flex-row mb-7" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "w-25 fw-bold text-muted" }, "Created ", -1))
const _hoisted_20 = { class: "w-75 fw-bold fs-6" }
const _hoisted_21 = {
  key: 0,
  class: "d-flex flex-row mb-7"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "w-25 fw-bold text-muted" }, "Payment Method ", -1))
const _hoisted_23 = { class: "w-75 fw-bold fs-6" }
const _hoisted_24 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_25 = ["src"]
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "fs-4 fw-bold" }
const _hoisted_28 = { class: "fs-6 fw-semibold text-gray-400" }
const _hoisted_29 = { class: "w-50 d-flex flex-column" }
const _hoisted_30 = {
  key: 0,
  class: "w-100 d-flex flex-column"
}
const _hoisted_31 = { class: "d-flex justify-content-between mb-5" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Upcoming Invoice", -1))
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" This is a preview of the invoice that will be billed on ")
const _hoisted_34 = /*#__PURE__*/_createTextVNode(". It may change if the subscription is updated. ")
const _hoisted_35 = { class: "table" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-bottom" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "DESCRIPTION"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "QTY"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "UNIT PRICE"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "AMOUNT")
  ])
], -1))
const _hoisted_37 = { class: "border-bottom" }
const _hoisted_38 = { colspan: "4" }
const _hoisted_39 = { class: "border-bottom" }
const _hoisted_40 = { class: "text-center" }
const _hoisted_41 = { class: "text-end" }
const _hoisted_42 = { class: "text-end" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Subtotal")
], -1))
const _hoisted_46 = { class: "text-end" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "GST (10%)", -1))
const _hoisted_50 = { class: "text-end" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Total")
], -1))
const _hoisted_54 = { class: "text-end" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Amount Due")
], -1))
const _hoisted_58 = { class: "text-end" }
const _hoisted_59 = {
  key: 1,
  class: "w-100 d-flex flex-column"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between mb-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "No Upcoming Invoice")
], -1))
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = { class: "d-flex flex-row justify-content-end pe-10 gap-5" }
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" Change ")
const _hoisted_64 = {
  key: 1,
  class: "btn btn-link disabled"
}
const _hoisted_65 = ["disabled", "data-kt-indicator"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, "Cancel Now", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode("Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_68 = [
  _hoisted_66,
  _hoisted_67
]
const _hoisted_69 = ["disabled", "data-kt-indicator"]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, "Cancel Subscription", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode("Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_72 = [
  _hoisted_70,
  _hoisted_71
]
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center pt-10 cursor-pointer" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "fs-1 fw-bolder" }, "Choose Your Plan")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PlanColumnView = _resolveComponent("PlanColumnView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.authUser.business_id === null)
      ? (_openBlock(), _createBlock(_component_el_empty, {
          key: 0,
          description: "Add business details to be able to subscribe"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              color: "#990abd",
              bg: "#990abd",
              onClick: _ctx.toBusinessDetails,
              plain: ""
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.loadingDetails)
            ? (_openBlock(), _createBlock(_component_el_skeleton, { key: 0 }, {
                template: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_el_skeleton, {
                        variant: "text",
                        rows: 3,
                        animated: ""
                      })
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_el_skeleton, {
                        variant: "text",
                        rows: 6,
                        animated: ""
                      })
                    ])
                  ]),
                  _createVNode(_component_el_divider),
                  _hoisted_7
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.hasSubscription)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          (!_ctx.loadingPlanProduct)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_11, [
                                  (!_ctx.loadingPlanProduct && !_ctx.loadPaymentMethod)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (_ctx.productDetails)
                                          ? (_openBlock(), _createElementBlock("h3", _hoisted_12, [
                                              _createTextVNode(_toDisplayString(_ctx.productDetails?.name) + " ", 1),
                                              (_ctx.subscription.status)
                                                ? (_openBlock(), _createBlock(_component_el_tag, {
                                                    key: 0,
                                                    class: "",
                                                    type: _ctx.subscriptionStatus().className,
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.subscription.status
                                ? _ctx.subscriptionStatus().text
                                : ''), 1)
                                                    ]),
                                                    _: 1
                                                  }, 8, ["type"]))
                                                : _createCommentVNode("", true),
                                              (_ctx.subscription.cancel_at_period_end)
                                                ? (_openBlock(), _createBlock(_component_el_tag, {
                                                    key: 1,
                                                    class: "ms-1",
                                                    type: "info",
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _hoisted_13,
                                                      _createTextVNode(" Cancels " + _toDisplayString(_ctx.formatDate(
                                  _ctx.subscription?.cancel_at,
                                  'DD MMM YYYY'
                                )), 1)
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true),
                                              (_ctx.subscription.status === 'trialing')
                                                ? (_openBlock(), _createBlock(_component_el_tag, {
                                                    key: 2,
                                                    class: "ms-1",
                                                    type: "warning",
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _hoisted_14,
                                                      _createTextVNode(" Trial Ends " + _toDisplayString(_ctx.formatDate(
                                  _ctx.subscription?.trial_end,
                                  'DD MMM YYYY'
                                )), 1)
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : (_openBlock(), _createBlock(_component_el_skeleton, {
                                              key: 1,
                                              variant: "text",
                                              rows: 2,
                                              animated: ""
                                            }))
                                      ], 64))
                                    : (_openBlock(), _createBlock(_component_el_skeleton, {
                                        key: 1,
                                        variant: "text",
                                        rows: 2,
                                        animated: ""
                                      }))
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                  _hoisted_16,
                                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.formatDate(
                          _ctx.subscription?.current_period_start,
                          'DD/MM/YYYY'
                        )) + " to " + _toDisplayString(_ctx.formatDate(
                          _ctx.subscription?.current_period_end,
                          'DD/MM/YYYY'
                        )), 1)
                                ]),
                                _createElementVNode("div", _hoisted_18, [
                                  _hoisted_19,
                                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.formatDate(_ctx.subscription.created, 'DD/MM/YYYY')), 1)
                                ]),
                                (_ctx.paymentMethodDetail)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                      _hoisted_22,
                                      _createElementVNode("span", _hoisted_23, [
                                        (!_ctx.loadPaymentMethod)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                              (_ctx.paymentMethodDetail?.card?.brand == 'visa')
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: require('@/assets/images/visa.svg')
                                                  }, null, 8, _hoisted_25))
                                                : _createCommentVNode("", true),
                                              (
                              _ctx.paymentMethodDetail?.card?.brand == 'mastercard'
                            )
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 1,
                                                    src: require('@/assets/images/mastercard.svg')
                                                  }, null, 8, _hoisted_26))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("div", null, [
                                                _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.paymentMethodDetail?.card?.brand?.toUpperCase()) + " **** " + _toDisplayString(_ctx.paymentMethodDetail?.card?.last4), 1),
                                                _createElementVNode("div", _hoisted_28, " Card expires at " + _toDisplayString(_ctx.paymentMethodDetail?.card?.exp_month) + "/" + _toDisplayString(_ctx.paymentMethodDetail?.card?.exp_year), 1)
                                              ])
                                            ]))
                                          : (_openBlock(), _createBlock(_component_el_skeleton, {
                                              key: 1,
                                              rows: 1,
                                              animated: ""
                                            }))
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : (_openBlock(), _createBlock(_component_el_skeleton, {
                                key: 1,
                                rows: 3,
                                animated: ""
                              }))
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          (!_ctx.loadUpcoming)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (Object.keys(_ctx.upcomingInvoiceDetails).length !== 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                      _createElementVNode("div", _hoisted_31, [
                                        _createElementVNode("div", null, [
                                          _hoisted_32,
                                          _hoisted_33,
                                          _createElementVNode("strong", null, _toDisplayString(_ctx.formatDate(
                            _ctx.upcomingInvoiceDetails.next_payment_attempt,
                            'DD/MM/YYYY'
                          )), 1),
                                          _hoisted_34
                                        ])
                                      ]),
                                      _createElementVNode("div", null, [
                                        _createElementVNode("table", _hoisted_35, [
                                          _hoisted_36,
                                          _createElementVNode("tbody", null, [
                                            _createElementVNode("tr", _hoisted_37, [
                                              _createElementVNode("td", _hoisted_38, _toDisplayString(_ctx.upcomingInvoiceDetails?.lines?.data[0]?.period
                                  ?.start
                                  ? _ctx.formatDate(
                                      _ctx.upcomingInvoiceDetails?.lines?.data[0]
                                        ?.period?.start,
                                      'DD/MM/YYYY'
                                    )
                                  : '-') + " to " + _toDisplayString(_ctx.upcomingInvoiceDetails?.lines?.data[0]?.period
                                  ?.end
                                  ? _ctx.formatDate(
                                      _ctx.upcomingInvoiceDetails?.lines?.data[0]
                                        ?.period?.end,
                                      'DD/MM/YYYY'
                                    )
                                  : '-'), 1)
                                            ]),
                                            _createElementVNode("tr", _hoisted_39, [
                                              _createElementVNode("td", null, _toDisplayString(_ctx.productDetails?.name), 1),
                                              _createElementVNode("td", _hoisted_40, _toDisplayString(_ctx.upcomingInvoiceDetails?.lines?.data[0]?.quantity), 1),
                                              _createElementVNode("td", _hoisted_41, _toDisplayString(_ctx.moneyFormat(
                                  _ctx.upcomingInvoiceDetails?.lines?.data[0]?.amount
                                )), 1),
                                              _createElementVNode("td", _hoisted_42, _toDisplayString(_ctx.moneyFormat(
                                  _ctx.upcomingInvoiceDetails?.lines?.data[0]
                                    ?.amount_excluding_tax
                                )), 1)
                                            ]),
                                            _createElementVNode("tr", null, [
                                              _hoisted_43,
                                              _hoisted_44,
                                              _hoisted_45,
                                              _createElementVNode("td", _hoisted_46, _toDisplayString(_ctx.moneyFormat(
                                  _ctx.upcomingInvoiceDetails?.subtotal_excluding_tax
                                )), 1)
                                            ]),
                                            _createElementVNode("tr", null, [
                                              _hoisted_47,
                                              _hoisted_48,
                                              _hoisted_49,
                                              _createElementVNode("td", _hoisted_50, _toDisplayString(_ctx.moneyFormat(_ctx.upcomingInvoiceDetails?.tax)), 1)
                                            ]),
                                            _createElementVNode("tr", null, [
                                              _hoisted_51,
                                              _hoisted_52,
                                              _hoisted_53,
                                              _createElementVNode("td", _hoisted_54, _toDisplayString(_ctx.moneyFormat(_ctx.upcomingInvoiceDetails?.total)), 1)
                                            ]),
                                            _createElementVNode("tr", null, [
                                              _hoisted_55,
                                              _hoisted_56,
                                              _hoisted_57,
                                              _createElementVNode("td", _hoisted_58, [
                                                _createElementVNode("strong", null, _toDisplayString(_ctx.moneyFormat(_ctx.upcomingInvoiceDetails?.amount_due)), 1)
                                              ])
                                            ])
                                          ])
                                        ])
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_59, _hoisted_61))
                              ], 64))
                            : (_openBlock(), _createBlock(_component_el_skeleton, {
                                key: 1,
                                rows: 5,
                                animated: ""
                              }))
                        ])
                      ]),
                      _createVNode(_component_el_divider),
                      _createElementVNode("div", _hoisted_62, [
                        (_ctx.subscription)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: "/subscription/change",
                              class: "btn btn-link"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_63
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createElementBlock("span", _hoisted_64, "Change")),
                        (_ctx.subscription.cancel_at_period_end)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 2,
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleCancelSubscription())),
                              class: _normalizeClass(["btn btn-danger", {
                    disabled: _ctx.enableCancel || _ctx.loadUpcoming,
                  }]),
                              disabled: _ctx.enableCancel || _ctx.loadUpcoming,
                              "data-kt-indicator": _ctx.loadCancel ? 'on' : null
                            }, _hoisted_68, 10, _hoisted_65))
                          : (_openBlock(), _createElementBlock("a", {
                              key: 3,
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleCancelAtPeriodEnd())),
                              class: _normalizeClass(["btn btn-danger", {
                    disabled: _ctx.enableCancel || _ctx.loadUpcoming,
                  }]),
                              disabled: _ctx.enableCancel || _ctx.loadUpcoming,
                              "data-kt-indicator": _ctx.loadCancel ? 'on' : null
                            }, _hoisted_72, 10, _hoisted_69))
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_73,
                      _createVNode(_component_PlanColumnView)
                    ], 64))
              ], 64))
        ], 64))
  ]))
}